export default __webpack_public_path__ + "static/media/gold-package.ce762382.png";